import { render } from "./LocalisationList.vue?vue&type=template&id=c3ad94d8&scoped=true"
import script from "./LocalisationList.vue?vue&type=script&lang=js"
export * from "./LocalisationList.vue?vue&type=script&lang=js"

import "./LocalisationList.vue?vue&type=style&index=0&id=c3ad94d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3ad94d8"]])

export default __exports__